import { useCallback } from 'react';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useLandingPagesApi } from 'services/api/landingPagesApi';
import styles from '../components/Chat/chat.module.scss';

const merger = (_, data) => data;

export const useHandleChatSubmit = () => {
    const { chatEditLandingPage } = useLandingPagesApi();
    const { patchExternalData } = useFormDataContext();

    const chatSubmitHandler = async landingPage => {
        const { accountName, landingPageId, summary, prompt } = landingPage;
        let newState;

        try {
            const {
                landingPage: newLandingPage,
                prompt: newPrompt,
                summary: newSummary,
            } = await chatEditLandingPage({
                accountName,
                landingPageId,
                prompt,
            });
            newState = {
                ...newLandingPage,
                landingPageId,
                prompt: newPrompt,
                summary: [...summary, newSummary],
            };
        } catch (error) {
            console.error(error);
            newState = {
                ...landingPage,
                prompt: '',
                summary: [
                    ...summary,
                    <FormattedMessage
                        id="landing.pages.edit.chat.error.message"
                        defaultMessage="Something went wrong while editing the landing page. Please try again."
                        className={styles['error']}
                    />,
                ],
            };
        }
        patchExternalData({ data: newState, merger });
        return newState;
    };

    return useCallback(chatSubmitHandler, [chatEditLandingPage, patchExternalData]);
};
